import request from '../utils/request'

const CHAT_WS_URL = process.env.VUE_APP_CHAT_WS || 'wss://web-backend.eae.international/chat-ws'

export function createChatSocket () {
  return new WebSocket(CHAT_WS_URL)
}

function chatRequest (functionName, params = {}, config = {}) {
  return request.post('/Assistant/index.php', {
    function: functionName,
    ...params
  }, config)
}

export function refreshChatNotificationToken (params) {
  return chatRequest('refreshChatNotificationToken', params, { timeout: 15000 })
}

export function getChatUserList () {
  return chatRequest('getChatUserList')
}

export function getUserConversations (params) {
  return chatRequest('getUserConversations', params)
}

export function setChatConversationPinned (params) {
  return chatRequest('setChatConversationPinned', params)
}

export function talkToSomeone (params) {
  return chatRequest('talkToSomeone', params)
}

export function addGroupConversation (params) {
  return chatRequest('addGroupConversation', params)
}

export function addGroupConversationMembers (params) {
  return chatRequest('addGroupConversationMembers', params)
}

export function chatSendMessage (params) {
  return chatRequest('sendMessage', params)
}

export function getConversationMessages (params) {
  return chatRequest('getConversationMessages', params)
}

export function getChatLinkMetadata (params) {
  return chatRequest('getChatLinkMetadata', params, { timeout: 15000 })
}

export function searchConversationMessages (params) {
  return chatRequest('searchConversationMessages', params)
}

export function getConversationFiles (params) {
  return chatRequest('getConversationFiles', params)
}

export function getChatMessage (params) {
  return chatRequest('getChatMessage', params)
}

export function getChatMessageContext (params) {
  return chatRequest('getChatMessageContext', params)
}

export function repairChatMessageQuote (params) {
  return chatRequest('repairChatMessageQuote', params)
}

export function readChatConversation (params) {
  return chatRequest('readChatConversation', params)
}

export function reactChatMessage (params) {
  return chatRequest('reactChatMessage', params)
}

export function editChatMessage (params) {
  return chatRequest('editChatMessage', params)
}

export function sendSelectedChatMessagesEmail (params) {
  return chatRequest('sendSelectedChatMessagesEmail', params)
}

export function markChatMessageTodo (params) {
  return chatRequest('markChatMessageTodo', params)
}

export function createChatMessageTodo (params) {
  return chatRequest('createChatMessageTodo', params)
}

export function getChatMessageTodo (params) {
  return chatRequest('getChatMessageTodo', params)
}

export function getConversationChatTodos (params) {
  return chatRequest('getConversationChatTodos', params)
}

export function getChatOnlineStatus (params) {
  return chatRequest('getChatOnlineStatus', params)
}

export function getChatQiniuToken () {
  return chatRequest('getQiniuToken')
}
